import {
  webProductEventContracts,
  webProductEventNames,
  webSamplingDefaults,
} from "./productEventContract.generated.mjs";

export { webProductEventContracts, webProductEventNames, webSamplingDefaults };
const webProductEventNameSet = new Set(webProductEventNames);

export const validateWebAnalyticsRemoteConfig = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return { accepted: false, reason: "Policy must be a JSON object." };
  }
  const allowedKeys = new Set(["enabled", "sampling", "serverZone"]);
  const unexpectedKey = Object.keys(value).find((key) => !allowedKeys.has(key));
  if (unexpectedKey) {
    return {
      accepted: false,
      reason: `Unexpected policy field: ${unexpectedKey}.`,
    };
  }
  if (typeof value.enabled !== "boolean") {
    return { accepted: false, reason: "Policy enabled must be Boolean." };
  }
  if (value.serverZone !== "EU") {
    return { accepted: false, reason: "Policy serverZone must be EU." };
  }
  if (value.sampling === undefined) {
    return { accepted: true, config: value };
  }
  if (
    !value.sampling ||
    typeof value.sampling !== "object" ||
    Array.isArray(value.sampling)
  ) {
    return { accepted: false, reason: "Policy sampling must be an object." };
  }
  const unknownEventName = Object.keys(value.sampling).find(
    (eventName) => !webProductEventNameSet.has(eventName),
  );
  if (unknownEventName) {
    return {
      accepted: false,
      reason: `Unknown or non-web sampling override: ${unknownEventName}.`,
    };
  }
  const invalidRate = Object.entries(value.sampling).find(
    ([, rate]) =>
      typeof rate !== "number" ||
      !Number.isFinite(rate) ||
      rate < 0 ||
      rate > 1,
  );
  if (invalidRate) {
    return {
      accepted: false,
      reason: `Invalid sampling rate for ${invalidRate[0]}.`,
    };
  }
  return { accepted: true, config: value };
};
